import { render, staticRenderFns } from "./RedeemVoucher.vue?vue&type=template&id=473a8c06&scoped=true&"
import script from "./RedeemVoucher.vue?vue&type=script&lang=js&"
export * from "./RedeemVoucher.vue?vue&type=script&lang=js&"
import style0 from "./RedeemVoucher.vue?vue&type=style&index=0&id=473a8c06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473a8c06",
  null
  
)

export default component.exports